window.addEventListener("DOMContentLoaded", () => {
  class pqShareStory extends HTMLElement {
    constructor() {
      super();
      // 初始化元素引用
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      let swiperDom = this.querySelector(".swiper");

      var swiper = new Swiper(swiperDom, {
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          1025: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
          481: {
            slidesPerView: "auto",
            spaceBetween: 24,
          },
          0: {
            slidesPerView: "auto",
            spaceBetween: 16,
          },
        },
      });
    }
  }
  // 注册自定义元素
  customElements.define("pq-share-story", pqShareStory);
});
